import { BasePaymentMethodsClient, PaymentMethod } from "@core/types";

class PaymentMethodsClient extends BasePaymentMethodsClient {
  async getPaymentMethods(): Promise<PaymentMethod[]> {
    throw new Error("PAYMENT METHODS NOT IMPLEMENTED");
  }
}

export default PaymentMethodsClient;
